module.exports = __webpack_public_path__ + "static/media/drop_arrow.de2a2ad8.svg";